import { render, staticRenderFns } from "./explain-index.vue?vue&type=template&id=78ce704f&scoped=true"
import script from "./explain-index.vue?vue&type=script&lang=js"
export * from "./explain-index.vue?vue&type=script&lang=js"
import style0 from "./explain-index.vue?vue&type=style&index=0&id=78ce704f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ce704f",
  null
  
)

export default component.exports